// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","loadingImage":"App_loadingImage__0PmfH"};